import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiShield, FiLock, FiEye, FiFileText } = FiIcons;

function PrivacyPolicy() {
  const sections = [
    {
      icon: FiEye,
      title: "Information We Collect",
      content: "We collect minimal information required to provide our services. This includes email addresses for premium download delivery and basic usage statistics to improve the app experience."
    },
    {
      icon: FiLock,
      title: "Data Security",
      content: "We use industry-standard encryption and secure payment processors (Lemon Squeezy) to ensure your data and transactions are protected. We never store your payment details on our servers."
    },
    {
      icon: FiFileText,
      title: "Usage of Posters",
      content: "The posters you create using our tool are yours to use. However, we do not store your generated images indefinitely. Please ensure you download your creations immediately."
    }
  ];

  return (
    <div className="bg-white min-h-screen">
      <div className="container mx-auto px-4 py-16 max-w-4xl">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-12"
        >
          <div className="flex items-center gap-4 mb-6">
            <div className="w-12 h-12 bg-emerald-100 rounded-xl flex items-center justify-center">
              <SafeIcon icon={FiShield} className="w-6 h-6 text-emerald-600" />
            </div>
            <h1 className="text-4xl font-bold text-slate-900">Privacy Policy</h1>
          </div>
          <p className="text-lg text-slate-600">
            Last updated: February 20, 2024. Your privacy is important to us.
          </p>
        </motion.div>

        <div className="space-y-12">
          {sections.map((section, idx) => (
            <motion.div 
              key={idx}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: idx * 0.1 }}
              className="flex gap-6"
            >
              <div className="shrink-0">
                <div className="w-10 h-10 bg-slate-50 rounded-lg flex items-center justify-center border border-slate-100">
                  <SafeIcon icon={section.icon} className="w-5 h-5 text-slate-400" />
                </div>
              </div>
              <div>
                <h2 className="text-xl font-bold text-slate-900 mb-3">{section.title}</h2>
                <p className="text-slate-600 leading-relaxed">{section.content}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
          className="mt-16 p-8 bg-slate-50 rounded-3xl border border-slate-100"
        >
          <h2 className="text-xl font-bold text-slate-900 mb-4">Cookies</h2>
          <p className="text-slate-600 mb-6">
            We use essential cookies to maintain your session and remember your preferences. You can disable cookies in your browser settings, but some features of the app may not function correctly.
          </p>
          <h2 className="text-xl font-bold text-slate-900 mb-4">Third Party Services</h2>
          <p className="text-slate-600">
            We use Google AdSense for advertising and Lemon Squeezy for payment processing. These services have their own privacy policies which we encourage you to review.
          </p>
        </motion.div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;